module.exports = require("./../../_gen/starling/extensions/ParticleSystem");